import React from 'react'
import { Link } from 'react-router-dom'

import { NavBarEntry } from '@app/NavBar'

import { latestInteractionsPath } from './paths'

export function useNavbarEntries(): NavBarEntry[] {
  return [
    {
      iconName: 'chat',
      title: 'Letzte Beratungen',
      EntryWrapper: ({ children }) => <Link to={latestInteractionsPath}>{children}</Link>,
      active: /^\/letzte-beratungen/
    }
  ]
}
